package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import app.smartcoding.realrate.localization.LocalStrings

enum class CreditRating(val color: Color) {
    EXCELLENT(Color(0xFF4CAF50)),
    GOOD(Color(0xFF2E7D32)),
    FAIR(Color(0xFFFF9800)),
    POOR(Color(0xFFEF6C00)),
    BAD(Color(0xFFC62828));

    val label: String
        @Composable
        get() = when (this) {
            EXCELLENT -> LocalStrings.current.ratingExcellent
            GOOD -> LocalStrings.current.ratingGood
            FAIR -> LocalStrings.current.ratingFair
            POOR -> LocalStrings.current.ratingPoor
            BAD -> LocalStrings.current.ratingBad
        }
}
